export const APP_ROUTES = {
  WAITING_ROOM: '/',
  OFFERS: '/tus-cuotas',
  AUTH: '/ingresar',
  AUTH_PARAMS: {
    WITHOUT_TOKEN: '/?error=token',
  },
  ONBOARDING: '/verificacion-datos',
  SCORE: '/pagos',
  PAYMENT_METHOD: '/pagos/metodo-de-pago',
  PAYMENT_STATE: '/pagos/estado-de-pago',
  PAYMENT_PLAN: '/pagos/plan-de-pagos',
  INSTALLMENTS: '/prestamo/plan-pagos',
  FREQUENT_QUESTIONS_SCORE: '/prestamo/preguntas-frecuentes',
  PAYMENT: '/prestamo/pago-exito',
  ERROR: '/error',
  CONTINUE_PROCESS: '/continua-tu-proceso',
  VALIDATION: '/validacion',
  LOADING: '/cargando',
  CALCULATE: '/prestamo/procesando',
  FREQUENT_QUESTIONS: '/preguntas-frecuentes',
  ERROR_01: '/error-01',
  ERROR_PAYMENT_02: '/error-payment-02',
  ERRORS: '/errors',
};
